export function isValidSpacingToken(theme, token) {
  return token in theme.tokens.spacing;
}